import { cn } from "@/lib/utils";

export const Logo = ({ className, imgClassName }) => (
    <div
        className={cn("relative overflow-hidden rounded-full bg-white shadow-md", className)}
        data-testid="omsivo-logo-badge"
    >
        <img
            src="/assets/omsivo-logo.png"
            alt="OMSIVO — Not just houses. We build concepts."
            className={cn("h-full w-full object-contain", imgClassName)}
            data-testid="omsivo-logo"
            draggable={false}
        />
    </div>
);
